/**
 * Feature Flags Configuration
 *
 * This file manages feature flags across environments using type-safe flag definitions.
 * Environment is determined by NEXT_PUBLIC_ENV variable set during build time.
 *
 * Priority order:
 * 1. NEXT_PUBLIC_ENV (set by CI/CD)
 * 2. NODE_ENV as fallback (development vs production)
 * 3. Default to production (safe mode)
 */

export interface FeatureFlags {
  ozhazard_bushfire_intelligence: boolean;
  nsw_water_compliance: boolean;
  vmap_vegetation_monitoring: boolean;
}

const productionFlags: FeatureFlags = {
  nsw_water_compliance: true,
  ozhazard_bushfire_intelligence: true,
  vmap_vegetation_monitoring: true,
};

const stagingFlags: FeatureFlags = {
  nsw_water_compliance: true,
  ozhazard_bushfire_intelligence: true,
  vmap_vegetation_monitoring: true,
};

const developmentFlags: FeatureFlags = {
  nsw_water_compliance: true,
  ozhazard_bushfire_intelligence: true,
  vmap_vegetation_monitoring: true,
};

/**
 * Get feature flags for current environment
 */
export const getFeatureFlags = (): FeatureFlags => {
  let env = process.env.NEXT_PUBLIC_ENV || "";

  // If not explicitly set, infer from NODE_ENV
  if (!env) {
    env = process.env.NODE_ENV === "production" ? "production" : "development";
  }

  switch (env) {
    case "staging":
      return stagingFlags;
    case "production":
      return productionFlags;
    case "development":
    default:
      return developmentFlags;
  }
};

// Export current flags for this build
export const featureFlags = getFeatureFlags();
